import React from 'react';

const ReportEffectResources = () => {
  return <div>resources</div>;
};

export default ReportEffectResources;
